export const PHOTOGALLERY_ANIMATION_TIME = 1.3;


// WEBPACK FOOTER //
// ./src/constants.js